// Weights are stored in kg; this shows them in the unit you chose (#191).

export const KG_PER_LB = 0.45359237;

/** "kg" or "lb" from a profile (null means kg). */
export const weightUnitOf = (profile) => (profile?.weightUnit === "lb" ? "lb" : "kg");

/** kg to the display unit, to 0.1 for kg and whole pounds for lb. */
export const toDisplayWeight = (kg, unit = "kg") => {
  const n = Number(kg);
  if (!Number.isFinite(n)) return null;
  return unit === "lb" ? Math.round(n / KG_PER_LB) : Math.round(n * 10) / 10;
};

/** A value in the display unit back to kg, to 0.1. */
export const fromDisplayWeight = (value, unit = "kg") => {
  const n = Number(value);
  if (!Number.isFinite(n)) return null;
  return Math.round((unit === "lb" ? n * KG_PER_LB : n) * 10) / 10;
};

/** "80 kg" / "176 lb". */
export const formatWeight = (kg, unit = "kg") => {
  const v = toDisplayWeight(kg, unit);
  return v == null ? "" : `${v} ${unit}`;
};

// ─── The unit the app shows weights in ──────────────────────────────────────
// Set from the Profile by WorkoutProvider as it renders, so the plain
// formatters (plan lines, history, curves) can show weights in it without
// threading a unit through every call. Prompts to the AI keep kg and don't
// use these. "kg" until a profile says otherwise, and in tests.
let shownUnit = "kg";

export const setShownWeightUnit = (unit) => {
  shownUnit = unit === "lb" ? "lb" : "kg";
};

export const shownWeightUnit = () => shownUnit;

/** A kg figure in the shown unit, number only: 100 → 220 in lb. */
export const shownWeight = (kg) => toDisplayWeight(kg, shownUnit) ?? kg;

/** "80 kg" / "176 lb" in the shown unit. */
export const showWeight = (kg) => formatWeight(kg, shownUnit);
